import React from 'react'
import "./Delived_Order_details_table.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Form, Table } from 'react-bootstrap'
import { IDS } from '../../../../../../utils/IDS'

function Delived_Order_details_table({ dontShowPrice, showCheck = false, products, selectedItems,
  setSelectedItems }) {
  const handleCheckboxChange = (product) => {
    setSelectedItems((prev) =>
      prev?.id === product.id ? null : product
    );
  };

  return (
    <>
      <div className='product_content_holder'>
        <div className='product_content'>
          {products?.map((product) => (
            <div className='product_detail_inner'>
              <div className='left_side'>
                {(showCheck) && (
                  <Form.Check
                    type="checkbox"
                    className="cancel_check"
                    checked={selectedItems?.id === product.id}
                    onChange={() => handleCheckboxChange(product)}
                  />

                )}

                <div className='img_holder'>
                  <img
                    src={IDS.IMG_URL + product?.Product?.image}
                  />
                </div>

                <div className='text_holder'>
                  <div className='product_name'>
                    <p>{product?.Product?.name || " "}</p>
                  </div>
                  {/* <p className='text-danger mt-2'></p> */}
                  {/* <div className='weight'>
                    <p>{showCheck ? `This Product Is not Returnable` : ""}</p>
                  </div> */}
                </div>
              </div>

              <div>
                <div className='qty_holder'>
                  <p>x {product?.quantity || "0"} {!dontShowPrice && <span className='price'>₹{Number(product?.Product?.price).toFixed(2) || "0"}</span>}</p>
                </div>
              </div>

            </div>
          ))}


          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/explore/top-products/product1.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Agarbatti <span className='inner_text'>(Rose)</span></p>
                </div>
                
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}

          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/explore/top-products/product2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Rudraksh  <span className='inner_text'>(5 Faces)</span></p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}
        </div>
      </div>
    </>
  )
}

export default Delived_Order_details_table
